<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Choose Exercise</cs-header-title>
  <cs-header-content>
    <div class="controls-row">
      <cs-input #searchInput class="search-input" iconName="search" autocomplete="off" [(value)]="searchText"
        type="text" name="searchText" inputmode="search" [placeholder]="'Search exercises...' | untranslated"
        (input)="handleSearchChanged()" />

      <cs-button tertiary icon="add" (click)="newExercise()">Create Exercise</cs-button>
    </div>
  </cs-header-content>
</cs-header>

<cs-content [loading]="loading">
  <cs-table class="exercise-table">
    @for (e of filteredExercises; track e) {
      <cs-table-row clickable (rowClick)="editExercise(e)">
        <cs-table-cell>{{ e.name }}</cs-table-cell>
        <cs-table-cell>{{ e.bwPc }}</cs-table-cell>
        <cs-table-cell>{{ e.rmTest }}</cs-table-cell>
        <cs-table-cell>{{ e.myoreps }}</cs-table-cell>
        <cs-table-cell>{{ e.standard }}</cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-content>